/** @file toonMaterial: a cel-shaded stand-in for a loaded material (colour and texture kept). */
import type { Material } from '@babylonjs/core/Materials/material.js';
import type { BaseTexture } from '@babylonjs/core/Materials/Textures/baseTexture.js';
import { Color3 } from '@babylonjs/core/Maths/math.color.js';
import type { Scene } from '@babylonjs/core/scene.js';
import { CellMaterial } from '@babylonjs/materials/cell/cellMaterial.js';

/** The albedo/diffuse colour and texture a PBR or standard material carries, when it has them. */
type Colourful = { albedoColor?: Color3; diffuseColor?: Color3; albedoTexture?: BaseTexture | null; diffuseTexture?: BaseTexture | null };

/** A `CellMaterial` with the base material's albedo (or diffuse) colour and texture; white without a base. */
export function toonMaterial(scene: Scene, base: Material | null, name: string): Material {
  const toon = new CellMaterial(name, scene);
  const b = (base ?? {}) as Colourful;
  toon.diffuseColor = (b.albedoColor ?? b.diffuseColor ?? Color3.White()).clone();
  const texture = b.albedoTexture ?? b.diffuseTexture ?? null;
  if (texture !== null) toon.diffuseTexture = texture;
  toon.computeHighLevel = true;
  return toon;
}
